import axios from '../../../store/sagas/axiosConfig';

// Helper function for GET request
const getRequest = async (url, contentType, timeoutSeconds) => {
  const config = {
    method: 'get',
    url,
    headers: {
      'Content-Type': contentType,
    },
    timeout: timeoutSeconds * 1000, // Must be in milliseconds
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(`Received error code ${error.response.status} from backend`);
    } else {
      throw error;
    }
  }
};

export default getRequest;
